import React from 'react';

export const AboutSection: React.FC = () => {
  const diferenciais = [
    {
      icon: 'ri-printer-fill',
      title: 'Qualidade de Impressão',
      description: 'Tecnologia de ponta para resultados superiores'
    },
    {
      icon: 'ri-palette-fill',
      title: 'Fidelidade da Cor',
      description: 'Cores vibrantes e precisas em cada estampa'
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Durabilidade',
      description: 'Tecidos resistentes que mantêm a qualidade'
    },
    {
      icon: 'ri-speed-fill',
      title: 'Entrega Rápida',
      description: 'Produção e entrega em até 24 horas'
    },
    {
      icon: 'ri-team-fill',
      title: 'Atendimento Personalizado',
      description: 'Suporte dedicado para cada cliente'
    },
    {
      icon: 'ri-bar-chart-fill',
      title: 'Alto Volume',
      description: 'Capacidade para grandes produções'
    }
  ];

  return (
    <section id="sobre" className="py-16 md:py-20 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16 lg:mb-20">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-2">Sobre a GMX Fortaleza</h3>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed px-4">
              A GMX Fortaleza está há anos no mercado de estamparia digital têxtil, oferecendo 
              <strong> tecnologia de ponta</strong>, prazos de produção reduzidos (entregas em até 24h), 
              e soluções completas para <strong>confecções, ateliês e marcas</strong> que exigem 
              <strong> qualidade e agilidade</strong>.
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8 mb-12 md:mb-16 lg:mb-20">
            {diferenciais.map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl flex items-center justify-center mb-5 md:mb-6">
                  <i className={`${item.icon} text-2xl md:text-3xl text-white`}></i>
                </div>
                <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3">{item.title}</h4>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
          
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 lg:gap-12 items-center">
              <div>
                <h4 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6">Nossa Experiência</h4>
                <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-6 md:mb-8 leading-relaxed">
                  Com anos de experiência no mercado têxtil, desenvolvemos processos otimizados 
                  que garantem a máxima qualidade em cada projeto. Nossa equipe especializada 
                  trabalha com equipamentos de última geração para entregar resultados excepcionais.
                </p>
                <div className="grid grid-cols-2 gap-4 md:gap-6">
                  <div className="text-center bg-purple-50 rounded-xl p-4 md:p-6">
                    <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-purple-600 mb-2">+100k</div>
                    <div className="text-xs sm:text-sm md:text-base text-gray-600 font-medium">Pedidos Entregues</div>
                  </div>
                  <div className="text-center bg-purple-50 rounded-xl p-4 md:p-6">
                    <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-purple-600 mb-2">24h</div>
                    <div className="text-xs sm:text-sm md:text-base text-gray-600 font-medium">Entrega Expressa</div>
                  </div>
                </div>
              </div>
              <div className="relative order-first lg:order-last">
                <div className="relative rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src="https://static.readdy.ai/image/5d7e5581bdb1497e1b9661cd362300f6/355a68139f600954dd3f43508f3623dd.jpeg"
                    alt="Instalações GMX Fortaleza - Estamparia Digital"
                    className="w-full h-64 sm:h-80 md:h-96 object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
